<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn :disabled="disabled" @click="click()" :id="id" icon v-bind="attrs" v-on="on" :height="width ? width :
      '38px'"
             :style="'padding: unset!important; width: '+(width ? width : '40px;')">
        <v-icon :style="defineSize()" :color="color">{{icon}}</v-icon>
      </v-btn>
    </template>
    <span>{{tooltip}}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    tooltip: {
      type: String
    },
    icon: {
      type: String
    },
    id: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    width: {
      type: String
    },
    large: {
      type: Boolean
    },
    small: {
      type: Boolean
    },
    color: {
      type: String
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
    defineSize() {
      if(this.large) return 'font-size:30px;'
      if(this.small) return 'font-size:20px;'
    }
  }
};
</script>
<style>
#default{
  color: var(--v-gray-darker1);
}
#editTooltip{
  background-color: var(--v-primary-base);
}
:deep .v-btn {
  padding: unset !important;
}
</style>